/** Pacific/Auckland date helpers for Academy training sessions (not UTC calendar dates). */

export const NZ_TIMEZONE = "Pacific/Auckland";

/** YYYY-MM-DD in Pacific/Auckland for the given instant (default: now). */
export function nzLocalDateString(date = new Date()) {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: NZ_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}

/** Human-readable NZ timestamp from an ISO UTC string stored on the server. */
export function formatUtcTimestampNz(isoString) {
  if (!isoString) return null;
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return null;
  return new Intl.DateTimeFormat("en-NZ", {
    timeZone: NZ_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZoneName: "short",
  }).format(d);
}

/**
 * True when stored session_date (calendar day label) differs from created_at in NZ.
 * Does not mutate data — used for Review Required flags only.
 */
export function sessionDateReviewRequired(sessionDate, createdAtIso) {
  if (!sessionDate || !createdAtIso) return false;
  const nzFromCreated = nzLocalDateString(new Date(createdAtIso));
  return sessionDate !== nzFromCreated;
}
